import { render, staticRenderFns } from "./ModalFilesMaterial.vue?vue&type=template&id=109d9426"
import script from "./ModalFilesMaterial.vue?vue&type=script&lang=js"
export * from "./ModalFilesMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports